<div class="p-x-24 p-y-20">
  <div class="row">
    <div class="col-10">
      <mat-form-field
        appearance="outline"
        color="primary"
        class="hide-hint w-100"
      >
        <input matInput placeholder="Buscar pantalla…" cdkFocusInitial [(ngModel)]="searchText" />
      </mat-form-field>
    </div>
    <div class="col-2 d-flex justify-content-end">
      <button
        mat-icon-button
        mat-dialog-close
        class="d-flex justify-content-center"
      >
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
  </div>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography search-dialog">
  <h4 class="f-s-18 f-w-600 mat-subtitle-1 m-b-16">Ir a una pantalla</h4>

  @for(item of resultados; track item.route) {
  <a
    [routerLink]="[item.route]"
    mat-dialog-close
    class="p-y-12 text-decoration-none d-flex align-items-center gap-12 text-hover-primary"
  >
    <span class="iconify icon-20" [attr.data-icon]="item.iconName" [style.color]="item.color"></span>
    <span>
      <h5 class="f-s-14 f-w-500 d-block mat-subtitle-1 hover-text m-0">
        {{ item.displayName }}
      </h5>
      <span class="f-s-12 mat-body-2" [style.color]="item.color">{{ item.modulo }}{{ item.grupo ? ' · ' + item.grupo : '' }}</span>
    </span>
  </a>
  } @empty {
  <p class="f-s-14 text-muted">Sin resultados para "{{ searchText }}"</p>
  }
</mat-dialog-content>
